// Generated by purs version 0.13.8
"use strict";
var Data_List_Types = require("../Data.List.Types/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Record = require("../Record/index.js");
var Type_Data_RowList = require("../Type.Data.RowList/index.js");
var GDefault = function (gDef) {
    this.gDef = gDef;
};
var Default = function (def) {
    this.def = def;
};
var gDefNil = new GDefault(function (v) {
    return {};
});
var gDef = function (dict) {
    return dict.gDef;
};
var defaultUnit = new Default(Data_Unit.unit);
var defaultString = new Default("");
var defaultRecord = function (dictGDefault) {
    return function (dictRowToList) {
        return new Default(gDef(dictGDefault)(Type_Data_RowList.RLProxy.value));
    };
};
var defaultNumber = new Default(0.0);
var defaultMaybe = new Default(Data_Maybe.Nothing.value);
var defaultList = new Default(Data_Monoid.mempty(Data_List_Types.monoidList));
var defaultInt = new Default(0);
var defaultBoolean = new Default(false);
var defaultArray = new Default(Data_Monoid.mempty(Data_Monoid.monoidArray));
var def = function (dict) {
    return dict.def;
};
var gDefCons = function (dictDefault) {
    return function (dictGDefault) {
        return function (dictIsSymbol) {
            return function (dictCons) {
                return function (dictLacks) {
                    return new GDefault(function (val) {
                        var rest = gDef(dictGDefault)(Type_Data_RowList.RLProxy.value);
                        var fieldName = Data_Symbol.reflectSymbol(dictIsSymbol)(Data_Symbol.SProxy.value);
                        return Record.insert(dictIsSymbol)()()(Data_Symbol.SProxy.value)(def(dictDefault))(rest);
                    });
                };
            };
        };
    };
};
module.exports = {
    def: def,
    gDef: gDef,
    Default: Default,
    GDefault: GDefault,
    defaultInt: defaultInt,
    defaultNumber: defaultNumber,
    defaultMaybe: defaultMaybe,
    defaultString: defaultString,
    defaultBoolean: defaultBoolean,
    defaultArray: defaultArray,
    defaultList: defaultList,
    defaultUnit: defaultUnit,
    defaultRecord: defaultRecord,
    gDefNil: gDefNil,
    gDefCons: gDefCons
};
